import { useQuery } from "@tanstack/react-query";
import type { Capabilities } from "./card-requirements.js";
import { useApiClient } from "./api-context.js";

/** CM is safe to show only when costs exist for every selling product. Partial
 * costing is treated as unavailable so no card displays an incomplete profit. */
export function useCmReady(): boolean {
  const api = useApiClient();
  const caps = useQuery({
    queryKey: ["capabilities"],
    queryFn: () => api.get<Capabilities>("/dashboard/capabilities"),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
  return Boolean(
    caps.data?.financialBasis === "profit"
      && caps.data.contributionMargin
      && !caps.data.cmGap,
  );
}
